import handleResponse from "./handleResponse";
import { AppDispatch } from "../redux/types";
import { SET_LOADING, SET_REPORT } from "../redux/actions";
import { ReportRecordTypes } from "../redux/types/reportTypes";

export default async (
  endpoint: string,
  dispatch: AppDispatch,
  params: unknown = {},
): Promise<void> => {
  dispatch({ type: SET_LOADING, payload: { target: endpoint, value: true } });

  const onSuccess = ({ records }: { records: Array<ReportRecordTypes> }) =>
    dispatch({ type: SET_REPORT, payload: { target: endpoint, value: records } });
  const queryParams = { query_params: params };

  await handleResponse("get", `/charts/${endpoint}`, onSuccess, dispatch, queryParams);

  dispatch({ type: SET_LOADING, payload: { target: endpoint, value: false } });
};
